/* eslint-disable no-new-func */
/* eslint-disable no-param-reassign */
let lastUcPostProcessJavaScript;
let mapDoNotUseThis;
const maxCacheSize = 128;
const getPostProcessJavaScript = () => typeof window !== 'undefined' && window.ucPostProcessJavaScript;
const getCodeCacheMap = () => {
  const ucPostProcessJavaScript = getPostProcessJavaScript();
  if (ucPostProcessJavaScript !== lastUcPostProcessJavaScript) {
    lastUcPostProcessJavaScript = ucPostProcessJavaScript;
    mapDoNotUseThis = undefined;
  }
  if (!mapDoNotUseThis) mapDoNotUseThis = new Map();
  return mapDoNotUseThis;
};
export function newFunction(args, code, options) {
  if (!options) options = {};
  if (options.async) code = `return (async()=>{\n${code}\n})()`;
  // -----------------------------------
  const cacheMap = getCodeCacheMap();
  const cacheKey = `${args.join(',')},${code}`;
  const lastFn = cacheMap.get(cacheKey);
  if (lastFn) return lastFn;
  // -----------------------------------
  const ucPostProcessJavaScript = getPostProcessJavaScript();
  if (typeof ucPostProcessJavaScript === 'function') code = ucPostProcessJavaScript(code);
  const fn = new Function(...args, code);
  cacheMap.set(cacheKey, fn);
  if (cacheMap.size >= maxCacheSize) cacheMap.delete(cacheMap.keys().next().value);
  return fn;
}